export const hotTableLicenseKey = "0b014-a057a-62a00-d4631-40c07";
export const messages = {
    VALID_LOCATION_DETAILS: "Please enter valid location details.",
    BRANCH_NAME_MAX_LENGTH: "Branch name should not contain more than 100 characters.",
    DISCARD_SUCCESS: "Changes discarded successfully.",
    DELETE_SUCCESS: "Deleted Successfully.",
    SAVE_SUCCESS: "Saved Successfully.",
    UNIQUE_MAIN_OFFICE: "There should be only one Main Office.",
    DUPLICATE_lOCATION_NAME: "Branch name already exists.",

};